<template>
  <section>
    <div
      class="jsj_share-panel"
      v-show="isShow"
      @click.self="isShow=false"
    >
      <div class="jsj_dlrLayer-bottom jsj_dlrShareLayer">
        <div class="jsj_dlrShare">
          <a
            class="jsj_dlrShare-item"
            href="javaScript:;"
            @click="emitShare('0')"
          >
            <em class="jsj_icon-pic">
              <img src="https://s.autoimg.cn/dealer/m/dealerUI/dlrShare/icon-weixin.png" />
            </em>
            <span>微信</span>
          </a>
          <a
            class="jsj_dlrShare-item"
            href="javaScript:;"
            @click="emitShare('1')"
          >
            <em class="jsj_icon-pic">
              <img src="https://s.autoimg.cn/dealer/m/dealerUI/dlrShare/icon-pyq.png" />
            </em>
            <span>朋友圈</span>
          </a>
        </div>
        <div class="jsj_dlrline-grey-line-4"></div>
        <a
          class="jsj_dlrLayerBottom-cancel"
          href="javaScript:;"
          @click="isShow=false"
        >取消</a>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'SharePanel',
  data () {
    return {
      isShow: false
    };
  },
  methods: {
    emitShare (type) {
      this.$emit('sharePanelClick', type);
      this.isShow = false;
    }
  }
}
</script>
<style type="text/css" >
.jsj_share-panel {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  font-size: 1rem;
  color: #fff;
  text-align: right;
  z-index: 10000;
}
.jsj_dlrShareLayer {
  background: #ffffff;
  border-radius: 0.88889rem 0.88889rem 0 0;
}
.jsj_dlrLayer-bottom {
  position: absolute;
  z-index: 11;
  bottom: 0;
  width: 100%;
}
.jsj_dlrShare {
  height: 6.33333rem;
  padding: 1.11111rem 0.55556rem;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
  font-size: 0;
  text-align: center;
}
.jsj_dlrShare-item {
  display: inline-block;
  width: 4.44444rem;
  text-align: center;
  text-decoration: none;
}
.jsj_dlrShare-item .jsj_icon-pic {
  position: relative;
  display: block;
  margin: 0 auto;
  width: 2.77778rem;
  height: 2.77778rem;
}
.jsj_dlrShare-item .jsj_icon-pic img {
  width: 100%;
  pointer-events: none;
}
.jsj_dlrShare-item span {
  display: block;
  font-size: 0.66667rem;
  padding-top: 0.44444rem;
  color: #111e36;
  line-height: 0.66667rem;
}
.jsj_dlrline-grey-line-4 {
  height: 0.22222rem;
  background: #f8f9fc;
}

.jsj_dlrLayerBottom-cancel {
  display: block;
  font-size: 0.88889rem;
  color: #111e36;
  text-align: center;
  line-height: 2.77778rem;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/share-panel.vue